<template lang="pug">
  .image-text
    .image-text-wrapper.page-layout__section
      .image-text__text-wrapper
        h3.image-text__headline {{ settings.title }}
        p.image-text__body {{ settings.body }}
        h4.image-text__subheadline {{ settings.sub_headline }}
        base-button(:href="settings.cta_url") {{ settings.cta_text }}
      .image-text__image-wrapper(
        :is="images.length > 1 ? 'VueSlickCarousel' : 'div'"
        v-bind="sliderSettings"
      )
        img.image-text__image(
          v-for="image, index in images"
          :src="image.src"
          :alt="image.alt"
          loading="lazy"
      )
</template>

<script>
  import BaseButton from 'scripts/components/buttons/BaseButton.vue';
  import VueSlickCarousel from 'vue-slick-carousel';

  export default {
    name: 'ImageText',
    components: {
      BaseButton,
      VueSlickCarousel,
    },
    props: {
      settings: Object,
      images: Array,
    },
    data() {
      return {
        sliderSettings: {
          arrows: false,
          dots: false,
          infinite: true,
          speed: 500,
          pauseOnHover: false,
          autoplay: true,
          autoplaySpeed: 2000,
          fade: true,
        },
      };
    },
  };
</script>

<style scoped lang="scss">
  .image-text {
    padding: 70px ($spacing-unit * 4) 0;
    border-top: $border-width solid $color-orange;
  }
  .image-text-wrapper {
    display: flex;
    flex-direction: column;

    @include tablet-up {
      flex-direction: row;
      padding-right: 60px;
    }
  }

  .image-text__text-wrapper {
    text-align: center;
    margin-bottom: 40px;

    @include tablet-up {
      margin-bottom: 0;
      width: 40%;
      padding-right: 60px;
      text-align: left;
    }
  }

  .image-text__headline {
    font-size: rem(32);
    font-weight: 500;
  }

  .image-text__body {
    color: $color-orange;
    font-family: $font-secondary;
    font-weight: 500;
    font-size: rem(22);
  }

  .image-text__subheadline {
    font-size: rem(24);
    font-weight: 500;
  }

  .image-text__image-wrapper {
    overflow: hidden;

    @include tablet-up {
      width: 60%;
    }

    img {
      display: block !important;
    }
  }
</style>
